/* @ngInject */
const ask = (
  trainData,
  trainFormat,
  utils,
  trainLocal,
  trainLabels,
  toaster,
  trainRequest,
  valueHandler
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (!valueHandler.isId(_id)) {
      if (valueHandler.isId(_id.id)) {
        _id = _id.id
      } else {
        return
      }
    }

    if (toaster.confirm(trainLabels.ask.delete)) {
      try {
        const wagons = trainRequest.getWagons(_id)
        if (wagons.length) {
          if (toaster.confirm(trainLabels.ask.deleteWithWagons)) {
            const message = await trainRequest.delete(_id)
            toaster.message(message)
            utils.removeFromArray(trainData.myTrains, _id)
            if (_back) {
              utils.$back()
            }
          }
        } else {
          const message = await trainRequest.delete(_id)
          toaster.message(message)
          utils.removeFromArray(trainData.myTrains, _id)
          if (_back) {
            utils.$back()
          }
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_train, _back = false) => {
    let train = utils.copy(_train)
    train.id = trainLocal.getCurrentId()
    train = trainFormat.server(train)

    try {
      const response = await trainRequest.update(train)
      toaster.message(response.message)
      utils.updateFromArray(trainData.myTrains, response.train)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/ask.service.js